import { useSelector } from 'react-redux';
import { selectIsSuburban } from '../../../../selectors/filters';

export const DEFAULT_TITLE = 'История объявлений в этом и соседних домах';
export const SUBURBAN_TITLE = 'История объявлений рядом';

export const useTitle = () => {
  const isSuburban = useSelector(selectIsSuburban);

  return isSuburban ? SUBURBAN_TITLE : DEFAULT_TITLE;
};
